import { type BadgeProps } from '@chronosphereio/chrono-ui';
import { type DocsLinkPath } from '@/components';
import { type RelatedResources } from '@/model/active-resource';

export interface NavigationMenu {
  render: (onClose: () => void) => React.ReactNode;
  ariaLabel: string;
}

export type HeaderBadge = Pick<BadgeProps, 'label' | 'variant' | 'showIcon'>;

export const EARLY_ACCESS_BADGE: HeaderBadge = { variant: 'new', label: 'Early access' };
export const INTERNAL_BADGE: HeaderBadge = { variant: 'warning', label: 'Internal only' };
export const INTERNAL_PREVIEW_BADGE: HeaderBadge = { variant: 'new', label: 'Internal preview', showIcon: false };
export const NEW_BADGE: HeaderBadge = { variant: 'new', label: 'New' };

/**
 * State used by the App Header
 *
 * title: title of the page
 * crumbs: breadcrumbs representing the page ancestors
 * prefix: component prefixing the page title, such as status icon or favorite button
 * relatedResources: resources of the same type, members of the same team or collection
 * navigationMenu: navigation menu with render function and ariaLabel, rendered in the title dropdown instead of the default Menu
 * badge: renders a badge next to the page title
 * editMode: renders a badge that says "Edit mode"
 */
export interface HeaderState {
  title: string;
  crumbs?: Array<{ name: string; href?: string }>;
  prefix?: React.ReactNode;
  relatedResources?: RelatedResources;
  navigationMenu?: NavigationMenu;
  badge?: HeaderBadge;
  pinnedScope?: boolean;
  showPinnedScopeInHeader?: boolean;
  editMode?: boolean;
  docsLink?: DocsLinkPath;
  docsLinkTitle?: string;
}
